import React from "react";
const defaultProcessSafetyData = [
  { metric: "Process Safety Incident Count (PSIC)", year: "" },
  { metric: "Process Safety Total Incident Rate (PSTIR)", year: "" },
  { metric: "Process Safety Incident Severity Rate (PSISR)", year: "" },
];

const ProcessSafetyMetricsTable = ({
  processSafetyTable,
  setProcessSafetyTable,
}) => {
  const safeProcessSafetyTable = Array.isArray(processSafetyTable)
    ? processSafetyTable
    : defaultProcessSafetyData;

  const handleInputChange = (rowIndex, value) => {
    const updatedData = [...safeProcessSafetyTable];
    updatedData[rowIndex].year = value;
    setProcessSafetyTable(updatedData);
  };

  return (
    <div>
      <div
        style={{
          marginTop: "20px",
          border: "1px solid #000",
          borderRadius: "8px",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr
              style={{
                backgroundColor: "#D3C9CE",
                color: "#000",
                fontWeight: "bold",
              }}
            >
              <th style={tableHeaderStyle}>Metric</th>
              <th style={tableHeaderStyle}>Year</th>
            </tr>
          </thead>
          <tbody>
            {safeProcessSafetyTable.map((row, index) => (
              <tr key={index}>
                <td
                  style={{
                    ...tableCellStyle,
                    backgroundColor: "#f5f5f5",
                    fontWeight: "bold",
                  }}
                >
                  {row.metric}
                </td>
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    value={row.year}
                    onChange={(e) => handleInputChange(index, e.target.value)}
                    style={inputFieldStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default ProcessSafetyMetricsTable;
